/**
 * Created by Carsten Hibbeler on 25.01.2016.
 */

import ReactDOM from 'external/react-dom';

Liferay.on('closePortlet', function (e) {
    ReactDOM.unmountComponentAtNode(document.getElementById('widget-container_' + e.portletId));
});

AUI().use('node-base', function (Y) {
    // Liferay (AUI) tests node.getDOMNode to check if a node is a Y_Node (node-core.js).
    // Because react nodes also implements getDOMNode the result of Y.Node.one is wrong.
    Y.Node.foo = 1;
    let UID = '_yuid';
    let Y_Node = Y.Node;
    Y.Node.one = Y.one = function (node) {
        let instance = null,
            cachedNode,
            uid;

        if (node) {
            if (typeof node === 'string') {
                node = Y_Node._fromString(node);
                if (!node) {
                    return null; // NOTE: return
                }
            } else if (node.getDOMNode && (!node.dataset || !node.dataset.reactid)) {
                return node; // NOTE: return
            }

            if (node.nodeType || Y.DOM.isWindow(node)) { // avoid bad input (numbers, boolean, etc)
                uid = (node.uniqueID && node.nodeType !== 9) ? node.uniqueID : node._yuid;
                instance = Y_Node._instances[ uid ]; // reuse exising instances
                cachedNode = instance ? instance._node : null;
                if (!instance || (cachedNode && node !== cachedNode)) { // new Node when nodes don't match
                    instance = new Y_Node(node);
                    if (node.nodeType !== 11) { // dont cache document fragment
                        Y_Node._instances[ instance[ UID ] ] = instance; // cache node
                    }
                }
            }
        }

        return instance;
    };

});



// WEBPACK FOOTER //
// ./js/liferay-custom.js